/**
 * Entrada em cascata de linhas de um `UseVirtualList`.
 *
 * O virtual list desmonta e remonta as linhas conforme o scroll. Se a decisão
 * "anima ou não" viesse pronta de um `computed`, ela ficaria congelada no valor
 * da chegada — o `computed` só recalcula quando uma dependência reativa muda, e o
 * relógio não é uma — e toda linha remontada repetiria a animação. Por isso o
 * que viaja na linha é QUANDO ela chegou; quem decide é o componente, no momento
 * em que monta, comparando com o relógio daquele instante.
 */

/** Quando a linha chegou e quanto a cascata deve esperar por ela. */
export type EntradaEmCascata = { chegouEm: number; atrasoMs: number };

/** Folga depois do atraso: uma linha montada logo após a vez dela ainda entra animada. */
const FOLGA_MS = 150;

/**
 * Atraso de animação a aplicar AGORA, na montagem; `null` = monta sem animar
 * (a janela da entrada já passou, ou a linha nunca entrou em cascata).
 */
export function atrasoNaMontagem(entrada: EntradaEmCascata | null | undefined, agora: number = Date.now()): number | null {
    if (!entrada) return null;
    const decorrido = agora - entrada.chegouEm;
    if (decorrido < 0 || decorrido > entrada.atrasoMs + FOLGA_MS) return null;
    return Math.max(0, entrada.atrasoMs - decorrido);
}
